var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/home-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "home-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.04 7.32006L14.28 3.29006C12.71 2.19006 10.3 2.25006 8.78999 3.42006L3.77999 7.33006C2.77999 8.11006 1.98999 9.71006 1.98999 10.9701V17.8701C1.98999 20.4201 4.05999 22.5001 6.60999 22.5001H17.39C19.94 22.5001 22.01 20.4301 22.01 17.8801V11.1001C22.01 9.75006 21.14 8.09006 20.04 7.32006ZM12.75 18.5001C12.75 18.9101 12.41 19.2501 12 19.2501C11.59 19.2501 11.25 18.9101 11.25 18.5001V15.5001C11.25 15.0901 11.59 14.7501 12 14.7501C12.41 14.7501 12.75 15.0901 12.75 15.5001V18.5001Z",
    fill: "#0877BC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.cd8ae18f5829c899040f651b93edec89.svg";
export { ForwardRef as ReactComponent };